import React, { useState, useEffect } from "react";
/** Services Import */
import Global from "../../services/Common/Global";
import Commons from "../../services/Common/Common";
import IndexedDb from "../../services/IndexedDb/IndexedDb";
/** Components Import */
import { Loading, Button, Dialog } from "../../Components/Bootstrap";
import { Card, Stack, Form } from "react-bootstrap";

function AdminFacilities() {
  const [loading, setLoading] = useState(false);
  const [serverList, setServerList] = useState([]);
  const [receiverList, setReceiverList] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [selectedTag, setSelectedTag] = useState({});
  const [dialogToggle, setDialogToggle] = useState(false);
  const [changeTagId, setChangeTagId] = useState("");

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    try {
      await SelectLogic();
      await SelectLogic1();
      await SelectLogic2();
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  // 서버 상태 조회
  const SelectLogic = async () => {
    setLoading(true);
    let _list = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.AdminFacilities.GetServer
      ).then((result) => {
        let data = result.data;
        // console.log("서버 상태 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data.result === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.result.length > 0) {
          let parse = JSON.parse(data.result);
          for (let i = 0; i < parse.length; i++) {
            _list.push(parse[i]);
          }
          setServerList(_list);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 수집기 조회
  const SelectLogic1 = async () => {
    setLoading(true);
    let _list = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.AdminFacilities.GetReceiver
      ).then((result) => {
        let data = result.data;
        // console.log("수집기 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.result.length > 0) {
          let parse = JSON.parse(data.result);
          for (let i = 0; i < parse.length; i++) {
            _list.push(parse[i]);
          }
          setReceiverList(_list);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // Tag정보 조회
  const SelectLogic2 = async () => {
    setLoading(true);
    let _list = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.AdminFacilities.GetTag
      ).then((result) => {
        let data = result.data;
        // console.log("Tag정보 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.result.length > 0) {
          let parse = JSON.parse(data.result);
          for (let i = 0; i < parse.length; i++) {
            _list.push(parse[i]);
          }
          setTagList(_list);
          // console.log(_list);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 이상 Tag 상세 조회
  const SelectLogic3 = async (_param) => {
    setLoading(true);
    let _list = [];

    try {
      await Commons.Axios(
        "get",
        Global.base.useUrl + Global.urls.AdminFacilities.GetErrorTag,
        { type: _param }
      ).then((result) => {
        let data = result.data;
        // console.log("이상 Tag 상세 조회: ", data);

        if (data.type == "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data.result.length > 0) {
          let parse = JSON.parse(data.result);
          for (let i = 0; i < parse.length; i++) {
            if (parse[i].cdId == "1") {
              _list.push({
                ...parse[i],
                tagId: parse[i].obuId.toString().substr(5),
              });
            } else {
              _list.push(parse[i]);
            }
          }
          // console.log("이상 Tag 상세 조회: ", _list);
          setStatusList(_list);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 이상 Tag 수정
  const SaveLogic = async () => {
    setLoading(true);

    try {
      await Commons.Axios(
        "post",
        Global.base.useUrl + Global.urls.AdminFacilities.Create,
        { ...selectedTag, newObuId: changeTagId }
      ).then((result) => {
        let data = result.data;
        // console.log("이상 Tag 수정: ", data);

        if (data.type === "Error") {
          throw new Error(data.message);
        } else if (data === "데이터가 없습니다.") {
          // throw new Error(data);
        } else if (data === "Already Exists Tag") {
          throw new Error("이미 등록된 Tag 입니다.");
        } else if (data === "Ok") {
          setChangeTagId("");
          setDialogToggle(false);
          Commons.Toast("success", "수정되었습니다.");
          SelectLogic3(selectedTag.cdId);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Card className="mb-2">
        <Card.Body className="cutom-card-body-evenly">
          {serverList.map((item, index) => {
            return (
              <div key={index} className="cutom-facilities-box-container">
                <div
                  className="cutom-facilities-box-circle"
                  style={{
                    backgroundColor: item.value == "on" ? "#0d6efd" : "red",
                  }}
                />
                <span className="cutom-facilities-box-text">{item.name}</span>
              </div>
            );
          })}
        </Card.Body>
      </Card>
      <Card className="mb-2">
        <Card.Body className="cutom-card-body-evenly">
          {receiverList.map((item, index) => {
            return (
              <div key={index} className="cutom-facilities-box-container">
                <span className="cutom-facilities-box-text">{item.name}</span>
                <div className="cutom-facilities-box-bg-box">
                  <div className="cutom-facilities-box-bg-box-set">
                    <span className="cutom-facilities-box-text">전체</span>
                    <div className="cutom-facilities-box-bg-box-set-item">
                      <span className="cutom-facilities-box-bg-box-set-item-text">
                        {item.value1}
                      </span>
                    </div>
                  </div>
                  <div className="cutom-facilities-box-bg-box-set">
                    <span className="cutom-facilities-box-text">이상</span>
                    <div className="cutom-facilities-box-bg-box-set-item1">
                      <span className="cutom-facilities-box-bg-box-set-item-text">
                        {item.value2}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Card.Body>
      </Card>
      <Card className="mb-2">
        <Card.Body className="cutom-card-body-evenly">
          {tagList.map((item, index) => {
            return (
              <div key={index} className="cutom-facilities-box-container1">
                <span className="cutom-facilities-box-text">{item.name}</span>
                <div className="cutom-facilities-box-bg-box">
                  <div className="cutom-facilities-box-bg-box-set">
                    <span className="cutom-facilities-box-text">전체</span>
                    <div className="cutom-facilities-box-bg-box-set-item">
                      <span className="cutom-facilities-box-bg-box-set-item-text">
                        {item.value1}
                      </span>
                    </div>
                  </div>
                  <div className="cutom-facilities-box-bg-box-set">
                    <span className="cutom-facilities-box-text">이상</span>
                    <Button
                      className="cutom-facilities-box-bg-box-set-item2"
                      variant="warning"
                      title={item.value2}
                      onClick={() => {
                        if (item.id == "비콘") {
                          SelectLogic3("1");
                        } else {
                          SelectLogic3("2");
                        }
                      }}
                    />
                  </div>
                  <div className="cutom-facilities-box-bg-box-set">
                    <span className="cutom-facilities-box-text">예비차</span>
                    <div className="cutom-facilities-box-bg-box-set-item1">
                      <span className="cutom-facilities-box-bg-box-set-item-text">
                        {item.value3}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Card.Body>
      </Card>
      <Card className="mt-2">
        <Card.Body className="custom-table-admin-header">
          <Stack direction="horizontal">
            <div className="p-2 custom-table-admin-header-text custom-table-text-width-80">
              구분
            </div>
            <div className="p-2 custom-table-admin-header-text custom-table-text-width-80">
              차량번호
            </div>
            <div className="p-2 custom-table-admin-header-text custom-table-text-width-80">
              Tag ID
            </div>
            <div className="p-2 custom-table-admin-header-text custom-table-text-width-64">
              변경
            </div>
          </Stack>
        </Card.Body>
        <div className="custom-table-grid-datas2">
          {statusList.map((item, index) => {
            return (
              <Card key={index}>
                <Card.Body className="custom-table-admin-body">
                  <Stack direction="horizontal">
                    <div className="p-2 custom-table-admin-body-text custom-table-text-width-80">
                      {item.cdNm}
                    </div>
                    <div className="p-2 custom-table-admin-body-text custom-table-text-width-80">
                      {item.vhcleNo}
                    </div>
                    <div className="p-2 custom-table-admin-body-text custom-table-text-width-80">
                      {item.cdId == "1" ? item.tagId : item.obuId}
                    </div>
                    <div className="p-2 custom-table-admin-body-text custom-table-text-width-64">
                      <Button
                        size="sm"
                        title="변경"
                        onClick={() => {
                          setSelectedTag(item);
                          setDialogToggle(true);
                        }}
                      />
                    </div>
                  </Stack>
                </Card.Body>
              </Card>
            );
          })}
        </div>
      </Card>
      <Dialog
        title="RF Tag ID를 수정하시겠습니까?"
        show={dialogToggle}
        onHide={() => setDialogToggle(false)}
        onClose={() => setChangeTagId("")}
        sumitButtonName="변경"
        onSumit={SaveLogic}
      >
        <div className="custom-dialog-inputs-container">
          <span style={{ minWidth: "35%" }}>차량번호</span>
          <span>{selectedTag.vhcleNo}</span>
        </div>
        <div className="custom-dialog-inputs-container">
          <span style={{ minWidth: "35%" }}>현재 Tag ID</span>
          <span>
            {selectedTag.cdId == "1" ? selectedTag.tagId : selectedTag.obuId}
          </span>
        </div>
        <div className="custom-dialog-inputs-container">
          <span style={{ minWidth: "35%" }}>변경</span>
          <Form.Control
            value={changeTagId}
            onChange={(e) => {
              if (selectedTag.cdId == "1" && changeTagId.length == 5) {
                return false;
              } else if (selectedTag.cdId == "2" && changeTagId.length == 6) {
                return false;
              } else {
                setChangeTagId(e.target.value);
              }
            }}
          />
        </div>
      </Dialog>
      <Loading show={loading} />
    </React.Fragment>
  );
}

export default AdminFacilities;
